exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-white[data-v-cfb7afc4]{-webkit-filter:brightness(0) invert(1);filter:brightness(0) invert(1)}", ""]);

// exports
